import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function ReadStatusFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();

  const readStatusOptions = [
    { label: 'Read', value: true },
    { label: 'Unread', value: false },
  ];

  return (
    <Dropdown
      options={readStatusOptions}
      value={fileManagerFilters?.is_read}
      placeholder="By Read Status"
      className="file-manager-select w-100"
      onChange={(e) => {
        onFilterChange({
          target: { name: 'is_read', value: e.value },
          value: e.value,
        });
        setSelectedRows([]);
      }}
      name="is_read"
    />
  );
}

export default ReadStatusFilter;
